import React from "react";
import styled from "styled-components";
import { Breakpoint } from "../enums/Breakpoints";

interface Props {
  label: string | JSX.Element;
  icon: JSX.Element;
  borderColor: string;
  textColor: string;
  className?: string;
}

const InfoBox = ({ label, icon, borderColor, textColor, className }: Props) => {
  return (
    <MainContainer borderColor={borderColor} className={className}>
      {!!icon && <IconContainer>{icon}</IconContainer>}
      <TextContainer textColor={textColor}>{label}</TextContainer>
    </MainContainer>
  );
};

const IconContainer = styled.div`
  display: flex;
  height: 16px;
`;

const MainContainer = styled.div<{ borderColor: string }>`
  border: 1px solid ${({ borderColor }) => borderColor};
  padding: 10px;
  display: flex;
  box-sizing: border-box;
`;

const TextContainer = styled.div<{ textColor: string }>`
  font-size: 14px;
  line-height: 16px;
  padding-left: 10px;
  color: ${({ textColor }) => textColor};

  @media ${Breakpoint.MaxMobile} {
    font-size: 12px;
    line-height: 14px;
  }
`;

export default InfoBox;
